/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiBridgeRecipientMappingUpdateRequest
 */
export interface InternalApiBridgeRecipientMappingUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalApiBridgeRecipientMappingUpdateRequest
     */
    fieldType: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiBridgeRecipientMappingUpdateRequest
     */
    selectedValue: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiBridgeRecipientMappingUpdateRequest
     */
    fieldValues: Array<string>;
}

/**
 * Check if a given object implements the InternalApiBridgeRecipientMappingUpdateRequest interface.
 */
export function instanceOfInternalApiBridgeRecipientMappingUpdateRequest(value: object): value is InternalApiBridgeRecipientMappingUpdateRequest {
    if (!('fieldType' in value) || value['fieldType'] === undefined) return false;
    if (!('selectedValue' in value) || value['selectedValue'] === undefined) return false;
    if (!('fieldValues' in value) || value['fieldValues'] === undefined) return false;
    return true;
}

export function InternalApiBridgeRecipientMappingUpdateRequestFromJSON(json: any): InternalApiBridgeRecipientMappingUpdateRequest {
    return InternalApiBridgeRecipientMappingUpdateRequestFromJSONTyped(json, false);
}

export function InternalApiBridgeRecipientMappingUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiBridgeRecipientMappingUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fieldType': json['fieldType'],
        'selectedValue': json['selectedValue'],
        'fieldValues': json['fieldValues'],
    };
}

export function InternalApiBridgeRecipientMappingUpdateRequestToJSON(json: any): InternalApiBridgeRecipientMappingUpdateRequest {
    return InternalApiBridgeRecipientMappingUpdateRequestToJSONTyped(json, false);
}

export function InternalApiBridgeRecipientMappingUpdateRequestToJSONTyped(value?: InternalApiBridgeRecipientMappingUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fieldType': value['fieldType'],
        'selectedValue': value['selectedValue'],
        'fieldValues': value['fieldValues'],
    };
}

